import { useState } from "react";
import { getUrlQueryParam } from "../../common/url";
const backendRestApiURL = process.env.REACT_APP_URL;
const backendToken = getUrlQueryParam("token");
const headerAuthorization = `Bearer ${backendToken}`;

export function usePatternFuncs(slides, customer_id) {
  const [data, setData] = useState(slides);
  const [selectedIdx, setSelectedIdx] = useState(
    data.length / 2 > 4 ? 4 : data.length / 2
  );

  const handleAddNewFile = (e) => {
    try {
      if (e.target !== null) {
        if (e.target.files.length > 0) {
          var id = 0;
          data.forEach((element) => {
            if (id < element.id) id = element.id;
          });
          id += 1;
          //{"Id":1587,"Thumbnail":"/media/u2sp0haj/collection_1_-_005.jpg?width=500px","Scale":10,"Rotate":0,"ThumbnailImg":"/media/u2sp0haj/collection_1_-_005.jpg?width=50px","IsPattern":true}
          const reader = new FileReader();
          reader.onloadend = async () => {
            const base64String = reader.result;
            if (base64String) {
              const [typePart, valuePart] = base64String.split(",");
              const type = typePart.match(/:(.+);/)[1];
              const body = {
                design_data: {
                  type: "pattern",
                  extension: type.split("/")[1],
                  content_file: valuePart || "",
                },
              };

              const res = await fetch(
                `${backendRestApiURL}/${process.env.REACT_APP_STORE_CODE}/V1/designhub/elements/${customer_id}`,
                {
                  method: "POST",
                  headers: {
                    Authorization: headerAuthorization,
                    "Content-Type": "application/json",
                  },
                  body: JSON.stringify(body),
                }
              );
              res.json().then((res) => {
                var logo = {
                  id: res?.element_data?.element_id,
                  Thumbnail: res?.element_data?.thumbnail,
                  ThumbnailImg: res?.element_data?.thumbnail,
                  Scale: res?.element_data?.scale,
                  Rotate: res?.element_data?.rotate,
                  file: res?.element_data?.thumbnail,
                  IsPattern: true,
                };
                var _logos = data;
                _logos.unshift(logo);
                setData([..._logos]);
                setSelectedIdx(1);
                console.log("set selected Id 1");
              });
            }
          };
          reader.readAsDataURL(e.target.files[0]);
        }
      }
    } catch (error) {
      console.log("error", error);
    }
  };

  const handleClick = (item, index) => () => {
    console.log("index", index, "item", item);
    setSelectedIdx(index);
    // swiperRef.current?.slideToLoop(index, 500);
    // window.patternHandling.selectedPattern(item);
  };

  return { data, selectedIdx, handleAddNewFile, handleClick };
}
